import { useEffect, useState } from "react";
import {
  ReactSelectSearchItem,
  StringIndexedDictionary,
} from "../../../../globalTypes";
import { OptionListData } from "../types";

type Params = {
  allOptionsById: StringIndexedDictionary<ReactSelectSearchItem>;
  initialIdsLeft: string[];
  headerLeft?: string;
  initialIdsRight: string[];
  headerRight?: string;
  searchEnabled?: boolean;
  listSize?: number;
};

const useLeftAndRightLists = ({
  allOptionsById,
  initialIdsLeft,
  headerLeft,
  initialIdsRight,
  headerRight,
  searchEnabled = true,
  listSize = 10,
}: Params) => {
  const [idsLeft, setIdsLeft] = useState<string[]>(initialIdsLeft);
  const [leftActiveIds, setLeftActiveIds] = useState<Set<string>>(new Set());
  const leftList: OptionListData = {
    options: idsLeft.map((id) => allOptionsById[id]),
    activeOptions: leftActiveIds,
    onChangeOfActiveOptions: setLeftActiveIds,
    searchEnabled,
    header: headerLeft,
    size: listSize,
  };

  const [idsRight, setIdsRight] = useState<string[]>(initialIdsRight);
  const [rightActiveIds, setRightActiveIds] = useState<Set<string>>(new Set());
  const rightList: OptionListData = {
    options: idsRight.map((id) => allOptionsById[id]),
    activeOptions: rightActiveIds,
    onChangeOfActiveOptions: setRightActiveIds,
    searchEnabled,
    header: headerRight,
    size: listSize,
  };

  const moveLeft = () => {
    const newIdsLeft = [...idsLeft, ...rightList.activeOptions];
    const newIdsRight = idsRight.filter(
      (id) => !rightList.activeOptions.has(id)
    );

    const newRightActiveIds = new Set<string>();
    const newLeftActiveIds = new Set([...rightActiveIds, ...leftActiveIds]);

    setIdsLeft(newIdsLeft);
    setIdsRight(newIdsRight);

    setRightActiveIds(newRightActiveIds);
    setLeftActiveIds(newLeftActiveIds);
  };

  const moveRight = () => {
    const newIdsLeft = idsLeft.filter((id) => !leftList.activeOptions.has(id));
    const newIdsRight = [...idsRight, ...leftList.activeOptions];

    const newRightActiveIds = new Set([...rightActiveIds, ...leftActiveIds]);
    const newLeftActiveIds = new Set<string>();

    setIdsRight(newIdsRight);
    setIdsLeft(newIdsLeft);

    setRightActiveIds(newRightActiveIds);
    setLeftActiveIds(newLeftActiveIds);
  };

  // Když se mi změní hodnoty ve storu
  useEffect(() => {
    setIdsLeft(initialIdsLeft);
    setIdsRight(initialIdsRight);
  }, [initialIdsLeft, initialIdsRight]);

  return {
    leftList,
    rightList,
    moveLeft,
    moveRight,
  };
};

export default useLeftAndRightLists;
